import { DashboardShell } from '@/modules/employer/pages/components/DashboardShell/DashboardShell'

export function Component() {
  return <DashboardShell />
}

Component.displayName = 'Dashboard'
